// src/components/shared/LoginDialog.vue
<script setup>
import { useDataStore } from '@/stores/data'
import { useMapStore } from '@/stores/map'
import { useAppStore } from '@/stores/app'
import ContactView from '@/components/shared/ContactView.vue'

const dataStore = useDataStore()
const mapStore = useMapStore()
const appStore = useAppStore()

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['close'])

const close = () => {
	emit('close')
}
</script>

<template>
	<div v-if="show" class="dialog-overlay" @click.self="close">
		<div class="dialog-container">
			<div class="dialog-content">
				<div class="dialog-header">
					<h5 class="dialog-title">Identifisering</h5>
					<div class="button close" @click="close">
						<i class="fa-solid fa-xmark"></i>
					</div>
				</div>

				<div class="flex justify-center items-center" v-if="dataStore.loadingAudience">
					<div class="m-10 animate-spin rounded-full border-4 w-16 h-16 border-black border-t-transparent"></div>
				</div>

				<div class="dialog-body" v-if="!dataStore.loadingAudience">
					<div class="mb-3 mt-3">
						<div class="status mb-2 pb-4" v-if="dataStore.respondentShortId">
							<i class="fas fa-circle-check blue"></i>
							<h4 class="mb-0">Takk, identifiseringen var vellykket og du er nå tilknyttet undersøkelsen.</h4>
						</div>
						<template v-else>
							<div class="status mb-1 pb-4">
								<i class="fas fa-circle-xmark red"></i>
								<h4 class="mb-0">Beklager, identifiseringen kunne ikke gjennomføres.</h4>
							</div>
							<div class="mb-4">Dersom du skrev inn en kode manuelt, vennligst sjekk at den er korrekt. Dersom du skannet en QR-kode, vennligst prøv igjen senere, eller ta kontakt med oss om problemet fortsetter.</div>
							<hr />
							<ContactView />
						</template>
					</div>
				</div>

				<div class="dialog-footer">
					<div class="button blue" @click="close()">Lukk</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
/* make the dialog minimum 80vw and 20vh */
.dialog-container {
	width: 90vw;
	min-height: 20vh;
}
.dialog-header {
	padding-top: 1rem;
	padding-bottom: 1rem;
}

.status {
	display: flex;
	gap: 1rem;
	justify-content: center;
	align-items: center;
}

.fas {
	font-size: 2.75rem;
	color: var(--color-success);
}

.fas.red {
	color: var(--color-danger);
}
</style>
